import React from "react";
import Classes from "./index.module.css";

const SearchBox = ({styleName="", placeholder="جستوجو", onChange=()=>{}, ref=null}) => {

  return (
    <div className={`gx-search-bar ${Classes.SearchBox} ${styleName} `}>
      <div className="gx-form-group">
        <input className="ant-input" type="search" placeholder={placeholder} onChange={onChange} ref={ref}/>
        <span className="gx-search-icon gx-pointer"><i className="icon icon-search"/></span>
      </div>
    </div>
  )
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};
